<app-resizable-draggable
  #resizableDraggable
  *ngIf="initialized"
  [class.maximized]="isMaximized"
  [styleDisabled]="isMaximized"
  [left]="100"
  [top]="100"
  [width]="400"
  [height]="300"
  [heightLimit]="40"
  [widthLimit]="40"
  [showControls]="!positionLocked"
  (onMove)="onMove($event)"
  (onResize)="onResize($event)"
>
  <div id="window-card-{{id}}" 
    [hidden]="!isReady"
    [class.maximized]="isMaximized"
    [class.focused]="hasFocus"
    class="window-card card shadow card-primary full-size bg-{{theme.bright}}">
    <div class="card-header d-flex">
      <span class="flex-grow-1 text-{{theme.brightContrast}}">{{title}}</span>
      <span (click)="minimize()" class="action action-minimize">
        <i class="fas fa-minus-circle"></i>
      </span>
      <span *ngIf="!isMaximized" (click)="maximize()" class="action action-maximize">
        <i class="fas fa-plus-circle"></i>
      </span>
      <span *ngIf="isMaximized" (click)="restore()" class="action action-restore">
        <i class="fas fa-plus-circle"></i>
      </span>
      <span (click)="close()" class="action action-close">
        <i class="fas fa-times-circle"></i>
      </span>
    </div>
  
    <div 
      [class.overflow]="overflow"
      class="card-body p-0 component-container">
      <ng-template dynamicComponentContainer></ng-template>
    </div>
  
    <div *ngIf="isDialog" class="card-footer">
    </div>
  </div>
  
</app-resizable-draggable>